import { render, staticRenderFns } from "./PromotionRateType.vue?vue&type=template&id=4e34b926&"
import script from "./PromotionRateType.vue?vue&type=script&lang=ts&"
export * from "./PromotionRateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports